import { FC, PropsWithChildren } from 'react';

import { Loader } from '@eon-home/react-library';

import { GenericError } from '@components';
import { WithErrorProps } from '../with-error';
import { WithLoaderProps } from '../with-loader';

type Props = WithErrorProps & WithLoaderProps;

export const WithErrorAndLoader: FC<Readonly<PropsWithChildren<Props>>> = ({
    error,
    loading,
    children,
    className,
    errorProps,
    loaderProps,
}) => {
    if (!loading && !error) {
        // eslint-disable-next-line
        return <>{children}</>;
    }

    if (loading) {
        return className ? (
            <div className={className}>
                <Loader {...loaderProps} />
            </div>
        ) : (
            <Loader {...loaderProps} />
        );
    }

    if (error) {
        return className ? (
            <div className={className}>
                <GenericError {...errorProps} />
            </div>
        ) : (
            <GenericError {...errorProps} />
        );
    }

    return null;
};
